module.exports = __webpack_public_path__ + "img/table-equal.14d1b43a.svg";